import React from 'react';

import { FormText } from './styled';

const Input = React.forwardRef<
    HTMLInputElement,
    React.InputHTMLAttributes<HTMLInputElement>
>((args, ref) => (
    <FormText {...args} ref={ref} type={args.type ? args.type : 'text'} />
));

export default Input;
